import { Component, app, ojs } from "modular-openscriptjs";
import { pageInfo, tab, empty } from "../../helpers";
import { api, PAGES } from "../../declarations";
import { routes } from "../../backendRoutes";
import { dom } from "../../fotastart";
import CapaTransfersView from "../Views/CapaTransfersView";
import Tabs from "../Blocks/Tabs";
import Spinner from "../Blocks/Spinner";

const h = app("h");

ojs(CapaTransfersView, Tabs, Spinner);

export default class TransfersPage extends Component {
    render(...args) {
        pageInfo(PAGES.TRANSFERS);

        this.getCapaTransfers();

        return h.div(
            { class: "pb-5 mb-5 container-xl py-md-5" },
            h.Tabs({
                holders: {
                    nav: h.div({
                        class: "nav nav-underline fs-5 nav-fill mb-3 bg-light sticky-top mt-3",
                    }),
                    body: h.div({ class: "tab-content" }),
                },
                tabs: [
                    tab(
                        h.button(
                            { class: "nav-link active" },

                            h.span("Out", h.i({ class: "fas fa-arrow-up" })),
                        ),
                        h.div(
                            { class: "tab-pane fade show active" },
                            h.div(
                                { hook: "tc-transferred-holder" },
                                h.Spinner(),
                            ),
                        ),
                    ),
                    tab(
                        h.button(
                            { class: "nav-link" },

                            h.span("In ", h.i({ class: "fas fa-arrow-down" })),
                        ),
                        h.div(
                            { class: "tab-pane fade" },
                            h.div({ hook: "tc-received-holder" }, h.Spinner()),
                        ),
                    ),
                    tab(
                        h.button(
                            { class: "nav-link" },

                            h.span(
                                "Payouts ",
                                h.i({ class: "fas fa-money-bill-wave" }),
                            ),
                        ),
                        h.div(
                            { class: "tab-pane fade" },
                            h.div(
                                { hook: "tc-withdrawals-holder" },
                                h.Spinner(),
                            ),
                        ),
                    ),
                ],
            }),

            ...args,
        );
    }

    async getCapaTransfers() {
        let res = await api.get(routes.transfers, {}, { silent: true });

        if (res) {
            let transfers = res.data.transfers;
            let receipts = res.data.receipts;
            let withdrawals = res.data.withdrawals;

            this.populateTabs(
                "transferred",
                "tc-transferred-holder",
                transfers,
            );
            this.populateTabs("received", "tc-received-holder", receipts);
            this.populateTabs("withdrawn", "tc-withdrawals-holder", withdrawals);
        } else {
            this.populateTabs("transferred", "tc-transferred-holder", []);
            this.populateTabs("received", "tc-received-holder", []);
            this.populateTabs("withdrawn", "tc-withdrawals-holder", []);
        }
    }

    populateTabs(type, name, data) {
        let holder = dom.get(`[hook="${name}"]`);
        dom.get("ojs-spinner", holder)?.remove();

        if (empty(data)) {
            h.p(
                {
                    parent: holder,
                    class: "fst-italic fw-500 text-center text-secondary",
                },
                `You haven't ${type} any Capa yet...`,
            );
            return;
        }

        for (let transaction of data) {
            h.CapaTransfersView(transaction, type, { parent: holder });
        }
    }
}
